import clsx from 'clsx';
import React from 'react';

type FooterProps = React.HTMLProps<HTMLDivElement>;

export const ProfileFooter = React.forwardRef<HTMLDivElement, FooterProps>((props, ref) => (
  <div ref={ref} className={clsx(props.className, 'modal-footer', 'p-4 md:pt-0 sm:p-10')}>
    {props.children}
  </div>
));
